<template>
  <TextureWrapper>
    <slot></slot>
    <div class="bg">
      <LazyImg :src="bg" :fit="'cover'"/>
    </div>
  </TextureWrapper>
</template>

<script>
import styled from 'vue-styled-components'
import * as _ from '@/styles/mixins'
import randomArrItem from '@/scripts/randomArrItem'
import LazyImg from '@/components/LazyImg'

// STYLES
const TextureWrapper = styled.div`
  ${_.absoluteTopFull};
  z-index: 0;
  -webkit-backface-visibility: hidden;
  -webkit-transform:translate3d(0,0,0);
  .bg {
    ${_.absoluteTopFull};
    z-index: 0;
  }
`

// VUE
export default {
  props: [
    'Data',
    'Textures'
  ],
  components: {
    TextureWrapper,
    LazyImg
  },
  data () {
    return {
      bg: randomArrItem(this.Textures.textureArr)
    }
  }
}
</script>
